import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MasterDataProvider } from "./context/MasterDataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="722245338695-1td72qpi9c70c4s944f9294bnh1srf2p.apps.googleusercontent.com">
      <BrowserRouter>
        {/* ✅ MasterData wraps App */}
        <MasterDataProvider>
          <App />
        </MasterDataProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
